// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"6b79e947","184":"76805a95","261":"02038710","335":"5a17be89","419":"7af81f1c","579":"232c0334","687":"47e88953","746":"e4c6165b"}[chunkId] + ".css";
};